import { useEffect } from 'react';

import { setRefreshToken } from 'common/utils/auth/refreshToken';
import { isIOS, isSafariBrowser } from 'common/utils/checkBrowserType';

import { CROSS_ORIGIN_MESSAGE_TYPES } from '../constants';
import { IS_DIFFERENT_CONTOURS } from 'entities/application/constants';
import { EMPTY_OBJECT } from 'shared/constants';

import config from 'config';

export const useTokensMessageListener = () => {
  useEffect(() => {
    window.addEventListener('message', (event) => {
      const { type, data } = event.data || EMPTY_OBJECT;
      if (
          IS_DIFFERENT_CONTOURS &&
          !isIOS &&
          !isSafariBrowser &&
          window.origin === config.contourB &&
          event.origin === config.contourA &&
          type === CROSS_ORIGIN_MESSAGE_TYPES.token
      ) {
        setRefreshToken(data);
      }
    });
  }, []);
};
